import * as React from "react";
const MessagingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M15.5 19.39h.5c4 0 6-1 6-6v-5c0-4-2-6-6-6H8c-4 0-6 2-6 6v5c0 4 2 6 6 6h.5c.31 0 .61.15.8.4l1.5 2c.66.88 1.74.88 2.4 0l1.5-2c.16-.22.53-.4.8-.4Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 8.39H7M17 13.39h-6"
    />
  </svg>
);
export default MessagingIcon;
